module.exports = __webpack_public_path__ + "img/cp3-5.6a74061d.jpg";